import { fabric } from 'fabric';
import { BLACK } from '../ItemColors';

const drawEquipment = (item, iconFill, iconSize) => {
  let group;

  let calcIconFill;
  switch (item.type) {
    case 'cone_large':
    case 'cone_small':
      calcIconFill = iconFill;
      break;
    default:
      calcIconFill = BLACK;
  }

  fabric.loadSVGFromString(item.svg, (objects, options) => {
    const canvasItem = fabric.util.groupSVGElements(objects, options);
    canvasItem.set({
      fill: calcIconFill,
      originX: 'center',
      originY: 'center',
    });
    canvasItem.scaleToHeight(item.sizes[iconSize].height);
    canvasItem.scaleToWidth(item.sizes[iconSize].width);

    group = new fabric.Group([canvasItem], {
      customProps: item,
      padding: 2,
      rotateAngle: 0,
    });

    group.toObject = function() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        customProps: item,
        iconFill,
        rotateAngle: this.rotateAngle,
      });
    };
  });

  return new Promise((resolve) => {
    if (group) {
      resolve(group);
    }
  });
};

export default drawEquipment;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Equipment.js